(function () {
  'use strict';

  var nav = document.querySelector('[data-wudy-gifts-nav]');

  function headerOffset() {
    var header = document.querySelector('.section-header, header.header, [data-section-type="header"]');
    return header ? header.offsetHeight : 72;
  }

  function scrollToEl(el) {
    if (!el) return;
    var navH = nav ? nav.offsetHeight : 0;
    var smooth =
      window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top: el.getBoundingClientRect().top + window.scrollY - headerOffset() - navH - 16,
      behavior: smooth ? 'smooth' : 'auto',
    });
  }

  function templatePrefix() {
    var node = document.querySelector('[id^="shopify-section-template--"]');
    if (!node) return null;
    var match = node.id.match(/^shopify-section-(template--\d+__)/);
    return match ? match[1] : null;
  }

  function sectionNode(suffix) {
    return document.querySelector('[id^="shopify-section-template--"][id$="__' + suffix + '"]');
  }

  function replaceSectionHtml(apiKey, html) {
    if (!html) return null;
    var wrap = document.createElement('div');
    wrap.innerHTML = html.trim();
    var fresh = wrap.firstElementChild;
    if (!fresh) return null;

    var current = document.getElementById('shopify-section-' + apiKey);
    if (current) {
      current.replaceWith(fresh);
      return fresh;
    }

    var suffix = apiKey.split('__').pop();
    var anchors = {
      gifts_occasion_picks: 'gifts_occasions',
      gifts_wrap: 'gifts_unbox',
    };
    var anchorSuffix = anchors[suffix];
    var anchor = anchorSuffix ? sectionNode(anchorSuffix) : null;
    if (anchor) {
      anchor.insertAdjacentElement('afterend', fresh);
      return fresh;
    }
    return null;
  }

  function bindOccasionChips() {
    document.querySelectorAll('[data-wudy-gifts-chip]').forEach(function (chip) {
      if (chip.dataset.wudyGiftsBound) return;
      chip.dataset.wudyGiftsBound = '1';
      chip.addEventListener('click', function () {
        var filter = chip.getAttribute('data-occasion-filter') || 'all';
        var label = chip.getAttribute('data-occasion-label') || chip.textContent.trim();
        var target = chip.getAttribute('data-target');

        document.querySelectorAll('[data-wudy-gifts-chip]').forEach(function (c) {
          c.classList.toggle('is-active', c === chip);
        });

        applyOccasionFilter(filter, label);

        if (target) {
          scrollToEl(document.querySelector(target));
        }
      });
    });
  }

  function giftGuideNeedsHeal() {
    if (!document.body.classList.contains('wudy-gifts-collection')) return false;

    var hasFilterChips = !!document.querySelector('[data-wudy-gifts-chip][data-occasion-filter]');
    var hasOccasionPicks = !!document.getElementById('wudy-gifts-occasion-picks');
    var fullTierPicks = document.querySelectorAll('#wudy-gifts-budget .wg-ladder__col:last-child .wg-ladder__pick');
    var curatedProducts = document.querySelectorAll('#wudy-gifts-curated .wg-spread__product');

    return (
      !hasFilterChips ||
      !hasOccasionPicks ||
      fullTierPicks.length < 3 ||
      curatedProducts.length < 9
    );
  }

  function healStaleGiftGuideCache(done) {
    if (!giftGuideNeedsHeal()) {
      done();
      return;
    }

    var prefix = templatePrefix();
    if (!prefix) {
      done();
      return;
    }

    var sectionKeys = [
      prefix + 'gifts_recipients',
      prefix + 'gifts_occasions',
      prefix + 'gifts_occasion_picks',
      prefix + 'gifts_budget',
      prefix + 'gifts_curated',
      prefix + 'gifts_wrap',
    ];

    Promise.all(
      sectionKeys.map(function (key) {
        return fetch(window.location.pathname + '?sections=' + encodeURIComponent(key), {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        })
          .then(function (res) {
            if (!res.ok) throw new Error('section fetch failed');
            return res.json();
          })
          .then(function (payload) {
            replaceSectionHtml(key, payload[key]);
          });
      })
    )
      .catch(function () {})
      .finally(done);
  }

  function occasionMatches(attr, filter) {
    if (!filter || filter === 'all') return true;
    if (!attr) return false;

    var tokens = attr.trim().split(/\s+/).filter(Boolean);
    if (tokens.length > 1) {
      return tokens.indexOf(filter) !== -1;
    }

    var glued = '-' + attr + '-';
    return glued.indexOf('-' + filter + '-') !== -1;
  }

  function applyOccasionFilter(filter, label) {
    var grid = document.querySelector('[data-wudy-gifts-occasion-grid]');
    if (!grid) return;

    var cards = grid.querySelectorAll('[data-occasions]');
    var visible = 0;

    cards.forEach(function (card) {
      var attr = (card.getAttribute('data-occasions') || '').trim();
      var show = occasionMatches(attr, filter);
      card.hidden = !show;
      if (show) visible += 1;
    });

    var labelWrap = document.querySelector('[data-wudy-gifts-filter-label]');
    var labelNode = document.querySelector('[data-wudy-gifts-filter-name]');
    if (labelWrap && labelNode) {
      if (filter && filter !== 'all') {
        labelNode.textContent = label || filter;
        labelWrap.hidden = false;
      } else {
        labelWrap.hidden = true;
      }
    }

    var empty = document.querySelector('[data-wudy-gifts-occasion-empty]');
    if (empty) {
      empty.hidden = filter === 'all' || filter === '' || visible > 0;
    }
  }

  if (nav) {
    var links = nav.querySelectorAll('a[href^="#"]');
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href');
        if (!id || id === '#') return;
        var target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        scrollToEl(target);
      });
    });

    var sections = [];
    links.forEach(function (link) {
      var id = link.getAttribute('href');
      if (id && id.charAt(0) === '#') {
        var el = document.querySelector(id);
        if (el) sections.push({ link: link, el: el });
      }
    });

    if (sections.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              sections.forEach(function (s) {
                s.link.classList.toggle('is-active', s.el === entry.target);
              });
            }
          });
        },
        { rootMargin: '-40% 0px -50% 0px', threshold: 0 }
      );
      sections.forEach(function (s) {
        io.observe(s.el);
      });
    }
  }

  function initGiftsAmbience() {
    var layer = document.querySelector('[data-wudy-gifts-ambience]');
    if (!layer || layer.dataset.wudyGiftsAmbienceInit === 'true') return;
    if (!document.body.classList.contains('wudy-gifts-collection')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    layer.dataset.wudyGiftsAmbienceInit = 'true';

    var targetX = 0;
    var targetY = 0;
    var currentX = 0;
    var currentY = 0;
    var scrollY = 0;
    var rafId = 0;

    function tick() {
      currentX += (targetX - currentX) * 0.07;
      currentY += (targetY - currentY) * 0.07;
      layer.style.transform =
        'translate3d(' + currentX.toFixed(2) + 'px, ' + (currentY + scrollY).toFixed(2) + 'px, 0)';
      rafId = requestAnimationFrame(tick);
    }

    window.addEventListener(
      'mousemove',
      function (e) {
        var nx = e.clientX / window.innerWidth - 0.5;
        var ny = e.clientY / window.innerHeight - 0.5;
        targetX = nx * 22;
        targetY = ny * 14;
      },
      { passive: true }
    );

    window.addEventListener(
      'scroll',
      function () {
        scrollY = window.scrollY * 0.035;
      },
      { passive: true }
    );

    rafId = requestAnimationFrame(tick);
  }

  healStaleGiftGuideCache(function () {
    bindOccasionChips();
    applyOccasionFilter('all');
    initReveal();
    initGiftsAmbience();
  });

  function initReveal() {
    if ('IntersectionObserver' in window) {
      document.querySelectorAll('[data-wudy-reveal]').forEach(function (el) {
        var revealIo = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                revealIo.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.12 }
        );
        revealIo.observe(el);
      });
    } else {
      document.querySelectorAll('[data-wudy-reveal]').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }
  }
})();
